if (document.querySelector('.banner__lecture')) {
  const joinButton = document.querySelectorAll('.banner__lecture button');
  joinButton.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const program = el.closest('.banner__lecture-button');
      const request = new XMLHttpRequest();
      request.open('POST', localData.siteURL, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.send(`action=createSignOnAction&locationID=${program.getAttribute('data-locationID')}&&id=${program.getAttribute('data-user')}`);
      request.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          const response = JSON.parse(request.responseText);
          if (response.data.status === 200) {
            window.location.href = response.data.url;
          }
        }
      };
    });
  });
};
